import { render, staticRenderFns } from "./portal_expander.vue?vue&type=template&id=7ea95ed8&"
import script from "./portal_expander.vue?vue&type=script&lang=js&"
export * from "./portal_expander.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports